<template>
  <div v-if="visible">
    <div class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog"
      style="display: block; background: #00000050">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body select-none">
            <div class="relative rounded-lg overflow-hidden h-[100px]">
              <img src="../../assets/images/profile-bg.png" alt="Background"
                class="w-full mobile:h-full tablet:h-auto object-cover">
              <button v-if="hideCloseBtn != 1" type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                data-bs-dismiss="modal" aria-label="Close" @click="hide">
                <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
              </button>
              <h3
                class="absolute top-0 left-0 w-full h-full flex items-center justify-center m-0 font-roboto text-center text-[20px] text-[#F67280]">
                {{ title }}
              </h3>
            </div>
            <div v-if="image != null" class="my-4 p-3 w-[80px] h-[80px] rounded-full mx-auto bg-[#F1F1F1]">
              <img :src="require(`@/assets/images/${image}`)" class="w-full h-full">
            </div>
            <p v-if="message.length <= 0" class="mb-3 font-roboto text-center text-[20px] text-[##333333]">
              {{ text }}
            </p>
            <p v-else v-html="message" class="mb-3 font-roboto text-center text-[20px] text-[##333333]">
            </p>
            <div class="text-center">
              <button class="font-roboto text-[16px] py-2 px-4 rounded-lg text-white bg-[#00B7C2]" @click="confirm">
                {{ buttonText }}
              </button>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/plugins/EventBus";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
export default {
  props: ['confirmButtonText'],

  data() {
    return {
      visible: false,
      title: "",
      text: "",
      image: null,
      onConfirm: {},
      buttonText: 'Continue',
      isShowConfirmText: false,
      hideCloseBtn: 0,
      message: '' // ✅ added correctly
    };
  },

  mounted() {
    EventBus.on("confirmDialogShow", (params) => {
      this.show(params);
    });
  },

  methods: {
    hide() {
      // this method is unchanged
      this.visible = false;
      document.documentElement.style.overflow = ''; // Reset HTML element
      document.documentElement.style.paddingRight = '0px';
      enableScroll()
    },
    confirm() {
      // we must check if this.onConfirm is function
      if (typeof this.onConfirm === "function") {
        // run passed function and then close the modal
        this.onConfirm();
        this.hide();
      } else {
        // we only close the modal
        this.hide();
      }
    },
    show(params) {
      // making modal visible
      this.visible = true;
      // setting title and text
      this.title = params.title;
      this.text = params.text;
      this.image = params.image;
      this.isShowConfirmText = params.isShowConfirmText
      // setting callback function
      this.onConfirm = params.onConfirm;
      this.message = params.message ?? ''
      this.buttonText = params.buttonText ?? 'Continue'
      this.hideCloseBtn = params.hideCloseBtn ?? 0

      if (this.isShowConfirmText) {
        this.buttonText = "Confirm"
      }

      document.documentElement.style.overflow = 'hidden'; // Target HTML element
      disableScroll()
      if (window.innerWidth >= 992) {
        document.documentElement.style.paddingRight = '15px';
      } else {
        document.documentElement.style.paddingRight = '0px';
      }

    },
  },
};
</script>